import React from 'react';
import {useHistory} from 'react-router';
import {useResetRecoilState} from 'recoil';
import {chosenColorsArray} from '../../state/colors';
import {colorDeclarationsProjectName} from '../../state/colorDeclarations';
import {declarationsCustomerMail} from '../../state/cutomerMail';
import {FiPenTool} from 'react-icons/fi';
import UIButton from '../UICommon/UIButton';
import UICard from '../UICommon/UICard';

const ColorDeclarationCreateNewCard: React.FC = () => {
  const history = useHistory();

  const resetProjectName = useResetRecoilState(colorDeclarationsProjectName);
  const resetCustomerMail = useResetRecoilState(declarationsCustomerMail);
  const resetChosenColors = useResetRecoilState(chosenColorsArray);

  const handleClick = () => {
    resetProjectName();
    resetChosenColors();
    resetCustomerMail();
    history.push('/fargdeklaration/new');
  };

  return (
    <UICard style='flex flex-col justify-center items-center font-Outfit max-h-[72vh]'>
      <FiPenTool className='text-5xl'/>
      <div className='text-26 font-medium py-4'>Skapa ny färgdeklaration</div>
      <div className='text-sm leading-4 font-normal text-brown-subtitle text-center max-w-[279px]'>
          Är det dags att skapa en ny färgdeklaration? klicka på knappen för att påbörja!
      </div>
      <div className='w-1/2 mx-auto my-7 md:flex justify-center items-center'>
        <UIButton type='full' text='Skapa ny' onClick={() => handleClick()}/>
      </div>
    </UICard>
  );
};

export default ColorDeclarationCreateNewCard;
